import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { BookMonth } from "@modules/bookMonths/types";

export function useBookMonthList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createModalRef = useRef<ModalRef>(null);
  const editModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<BookMonth>({
    resource: "v2/bookstore/book_month_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-year,-month" },
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createModalRef,
    editModalRef,
    refetch,
    setSelectedRows,
    translate,
  };
}
